import {
    List,
    Create,
    Edit,
    SimpleForm,
    TextInput,
    TextField,
    EditButton,
    Resource,
    ReferenceInput,
    Show,
    Filter,
    AutocompleteInput,
    SelectInput,
    Datagrid,
    ReferenceField,
    FunctionField,
    DateField} from "react-admin";
import { Chip } from "@material-ui/core";

import { useEffect, useState } from "react";
import { useForm } from "react-final-form";

  const Filters = (props) => (
    <Filter {...props}>
      <TextInput label="Search" source="article.name" alwaysOn />
      <ReferenceInput label="Project" source="projectId" reference="projects" perPage={500} sort={{ field: "name", order: "ASC" }} alwaysOn>
        <SelectInput optionText="name" />
      </ReferenceInput>
      <SelectInput
        label="Sent by API"
        source="apiServing"
        choices={[
          { id: "served", name: "Sent" },
          { id: "shadowed", name: "Not sent (another project is sent)" },
          { id: "not_served", name: "Not sent (no article with metrics)" },
        ]}
        alwaysOn
      />
      <ReferenceInput label="Reference" source="article.reference" reference="articles">
        <TextInput source="name" />
      </ReferenceInput>
      <TextInput label="Ecom reference" source="ecomReference" />
    </Filter>
  );

  // Which row the external API sends when the same ecom reference is loaded in
  // several projects (backend adds `apiServing` to each row).
  const API_SERVING_STYLE = {
    served: { label: "Sent", background: "#2e7d32" },
    shadowed: { label: "Not sent", background: "#757575" },
    not_served: { label: "Not sent", background: "#d32f2f" },
  };

  const ApiServingField = ({ record }) => {
    const serving = record?.apiServing;
    if (!serving) return null;
    const style = API_SERVING_STYLE[serving.status] || API_SERVING_STYLE.not_served;
    const detail = serving.status === "shadowed"
      ? `${serving.servedProjectName} is sent`
      : serving.status === "not_served"
        ? "no article with metrics"
        : serving.projectCount > 1
          ? `also in ${serving.projectCount - 1} other project${serving.projectCount > 2 ? "s" : ""}`
          : "";
    return (
      <span style={{ whiteSpace: "nowrap" }}>
        <Chip size="small" label={style.label} style={{ background: style.background, color: "white", height: 18, fontSize: 11 }} />
        {detail && <span style={{ fontSize: 12, color: "rgba(0,0,0,0.6)", marginLeft: 6 }}>{detail}</span>}
      </span>
    );
  };

  const EntityList = (props) => {
    return (
      <List {...props} filters={Filters(props)}>
        <div style={{marginTop: '15px'}}>
          <Datagrid rowClick="show">
            <TextField source="article.name" label="Article Name" />
            <TextField source="id" label="Id" />
            <ReferenceField source="projectId" reference="projects" label="Project">
              <TextField source="name" />
            </ReferenceField>
            <TextField source="article.reference" label="Reference" />
            <TextField source="ecomReference" label="Ecom reference" />
            <FunctionField label="Sent by API" sortable={false} render={(record) => <ApiServingField record={record} />} />
            <TextField source="size" label="Size" />
            <DateField source="createdAt" label="Creation date"/>
            <EditButton />
          </Datagrid>
        </div>
      </List>
    );
  };

  const ShowEntity = (props) => {
    return (
      <Show {...props}>
        <SimpleForm>
            <TextField source="article.name" />
            <TextField source="id" label="Id" />
            <ReferenceField source="projectId" reference="projects" label="Project">
              <TextField source="name" />
            </ReferenceField>
            <TextField source="article.reference" label="Reference" />
            <TextField source="ecomReference" label="Ecom reference" />
            <TextField source="size" label="Size" />
            <DateField source="createdAt" label="Creation date"/>
            <EditButton />
        </SimpleForm>
      </Show>
    );
  };

  const CustomReferenceTextInput = ({parameter, name, ...rest}) => {
    const form = useForm();
    const { choices } = rest;

    useEffect(() => {
      if (choices.length === 1) {
        form.change(parameter, choices[0][parameter]);
      }
    },[choices])

    return <TextInput source={parameter} label={name} required={true} disabled {...rest} />
  }

  const CreateEntity = (props) => {
    const [idSelected, setIdSelected] = useState("")

    const handleChange = id => setIdSelected(id)

    return (
      <Create {...props}>
        <SimpleForm>
          <ReferenceInput
            label="Article"
            source="articleId"
            reference="articles"
            onChange={handleChange}
            filterToQuery={searchText => ({ name: `%${searchText}%` })}
            perPage={100}
          >
              <AutocompleteInput
                optionText="name"
                required={true}
              />
          </ReferenceInput>
          <ReferenceInput label="Reference" source="reference" reference="articles" filter={{ id: idSelected }}>
            <CustomReferenceTextInput name={"Reference"} parameter={'reference'} />
          </ReferenceInput>
          <TextInput source="ecomReference" label="Ecom reference" required={true} />
          <TextInput source="size" label="Size" />
          <ReferenceInput className="ecommerce-reference-project-id-hidde" label="Project id" source="projectId" reference="articles" filter={{ id: idSelected }}>
            <CustomReferenceTextInput name={"Project id"} parameter={'projectId'} />
          </ReferenceInput>
        </SimpleForm>
      </Create>
    );
  };

  const EditEntity = (props) => {
    const [idSelected, setIdSelected] = useState("");
    const [showAutocomplete, setShowAutocomplete] = useState(false);

    const handleChange = id => setIdSelected(id);
    const handleFocus = () => setShowAutocomplete(true);

    return (
      <Edit {...props}>
        <SimpleForm>
          {
            !showAutocomplete
            ? <TextInput source="article.name" label="Article" onFocus={handleFocus} />
            : <ReferenceInput
                label="Article"
                source="article.id"
                reference="articles"
                onChange={handleChange}
                filterToQuery={searchText => ({ name: searchText })}
                perPage={100}
              >
                <AutocompleteInput
                  optionText="name"
                  required={true}

                />
              </ReferenceInput>
          }
          <ReferenceInput label="Reference" source="reference" reference="articles" filter={{ id: idSelected }}>
            <CustomReferenceTextInput name={"Reference"} parameter={'reference'} />
          </ReferenceInput>
          <TextInput source="ecomReference" label="Ecom reference" required={true} />
          <TextInput source="size" label="Size" />
        </SimpleForm>
      </Edit>
    );
  };



  const entityResource = () => <Resource
    name="ecom-reference-article"
    options={{ label: 'Ecommerce reference', menuGroup: 'Articles'}}
    list={EntityList}
    create={CreateEntity}
    edit={EditEntity}
    show={ShowEntity} />;

  export default entityResource;